// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * Contains additional options for an entity raycast operation.
 */
export default class EntityRaycastOptions {
  /**
   * Maximum distance, in blocks, to process the raycast.
   */
  "maxDistance": number;
}
